import type { ApiResponse } from '@types';
import { extractErrorMessage } from '@lib/logger/extractErrorMessage.ts';
import { writeErrorLog } from '@lib/logger/logError.ts';

export function handleError  <T = never> (
  message: string,
  error: unknown,
  source: string
): ApiResponse<T>  {
  const errorMessage = extractErrorMessage(error);

  void writeErrorLog(
    message,
    source,
    {
      error: errorMessage,
      rawError: error,
    }
  );

  return {
    success: false,
    error: {
      message,
      raw: errorMessage,
    },
  };
}